<app-joii-header [showNotificationBell]="true" [config]="menu"></app-joii-header>
<router-outlet></router-outlet>
<app-joii-footer [hideFooterPaths]="hideFooterPaths"></app-joii-footer>